export default {
  MuiTable: {
    size: 'small'
  },
  MuiButton: {
    disableElevation: true
  },
  MuiTooltip: {
    arrow: true
  },
  MuiTextField: {
    margin: 'dense'
  },
  MuiFormControl: {
    margin: 'dense'
  }
};
